import { Outlet } from "react-router";

import { DefaultTitle } from "@punto/frontend-shared/providers/head-provider";
import { FullScreenLoader } from "@punto/ui/components/full-screen-loader";

import { RootProvider } from "@/modules/root/components/root-provider";
import { routePaths } from "@/router/route-paths";

import { authenticatedRoutes } from "./authenticated-routes";
import { ErrorBoundary } from "./error-boundary";
import { publicRoutes } from "./public-routes";

export const appRoutes = [
  {
    path: routePaths.base,
    errorElement: <ErrorBoundary />,
    hydrateFallbackElement: <FullScreenLoader />,
    element: (
      <RootProvider>
        <DefaultTitle />
        <Outlet />
      </RootProvider>
    ),
    children: [...publicRoutes, ...authenticatedRoutes],
  },
];
